import { ForgottenPassword } from "@src/components/modules/auth/forgotten-password";
import { NoIndexHead } from "@src/components/widgets/NoIndexHead/NoIndexHead";
import { createFileRoute } from "@tanstack/react-router";

const ForgotPassword = () => {
  return (
    <>
      <NoIndexHead />
      <ForgottenPassword />
    </>
  );
};
export const Route = createFileRoute("/forgot-password")({
  component: ForgotPassword,
});
